import React from 'react';
import FascinatingFindsFieldRenderer from './fields/FascinatingFindsFieldRenderer';

export default function FormStep(props) {
  const { step } = props;
  if (!step) return null;
  const fields = step.fields || [];
  const headingFollowsConsent = fields[0] === 'consent_permission';
  const visibleFields = headingFollowsConsent
    ? fields.filter((fieldId) => fieldId !== 'consent_permission')
    : fields;
  return (
    <section className="wizard-form-step">
      {headingFollowsConsent && (
        <FascinatingFindsFieldRenderer fieldId="consent_permission" {...props} />
      )}
      <h2 className="wizard-step-heading">{step.title}</h2>
      {visibleFields.map((fieldId) => (
        <FascinatingFindsFieldRenderer key={fieldId} fieldId={fieldId} {...props} />
      ))}
    </section>
  );
}
